import { AppState } from "../rootReducer";
import { createSelector } from "reselect";
import { getUserId } from "../user/selectors";

export const getReceivers = (state: AppState) => state.message.receivers || [];

export const getUserClientSelectedName = (state: AppState) =>
  state.message.userSelectedClientName;

export const getConversationId = (state: AppState) =>
  state.message.conversationId;

export const getConversations = (state: AppState) =>
  state.message.conversations || [];

export const getSortedConversations = createSelector(
  getConversations,
  conversations => {
    return [...conversations].sort((a, b) => {
      return (
        new Date(b.latestMessage.createdAt).getTime() -
        new Date(a.latestMessage.createdAt).getTime()
      );
    });
  },
);

export const getSelectedConversation = createSelector(
  getConversations,
  getConversationId,
  (conversations, conversationId) => {
    return conversations.find(el => el._id === conversationId) || {};
  },
);

export const getReceiverId = (state: AppState) => state.message.receiver?._id;

export const getMessagePage = (state: AppState) => state.message.messagePage;

export const getLoadingMessage = (state: AppState) =>
  state.message.loadingMessage;

export const getMessages = (state: AppState) => state.message.messages;

export const getMessagesIds = (state: AppState) => state.message.messagesIds || [];

export const getMessagesByIds = (state: AppState) => state.message.messagesByIds || {};

export const getMessagesChatRequesting = (state: AppState) =>
  state.message.chatRequesting || false;

export const getMessageRequesting = (state: AppState) =>
  state.message.requesting || false;

export const getReceiversWithoutUser = createSelector(
  getReceivers,
  getUserId,
  (receivers, userId) => {
    return receivers.filter(el => el._id !== userId);
  },
);
